var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgDiamondGemOutline = function SvgDiamondGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.5 132L530 141.5L537 144.5L689.5 254L703 283L587.5 397L535.5 444L455 518L363.5 602L255 504L135 391L25 281.5L34 258.5L97 209L180 144.5L241.5 133L285 128.5L363 126L418 128.5L461.5 132Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgDiamondGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/diamond-gem-outline.f1650853f369bc7fc42be67c3ede0edc.svg";